export const configCGI = {
  type: "bar",
  plugins: {
    title: {
      display: true,
      text: "CGI (Impression Clinique Globale) (sur les 6 premiers mois)",
      font: { size: 14 },
      padding: 20,
    },
    legend: {
      position: "bottom",
      labels: { font: { size: 14 } },
    },
    datalabels: {
      display: false,
    },
  },
  responsive: true,
  scales: {
    x: {
      stacked: false,
    },
    y: {
      beginAtZero: true,
      suggestedMax: 7,
    },
  },
};

export const dataConfigCGI = (data) => ({
  labels: data.labels,
  datasets: [
    {
      label: "Impression positive",
      data: data["cgi-positive"],
      backgroundColor: "#3B8630",
      borderRadius: {
        topLeft: 6,
        topRight: 6,
        bottomLeft: 0,
        bottomRight: 0,
      },

      borderSkipped: false,
    },
    {
      label: "Impression modérée",
      data: data["cgi-moderate"],
      backgroundColor: "#F2A644",
      borderRadius: {
        topLeft: 6,
        topRight: 6,
        bottomLeft: 0,
        bottomRight: 0,
      },

      borderSkipped: false,
    },
    {
      label: "Impression négative",
      data: data["cgi-negative"],
      backgroundColor: "#CA3142",
      borderRadius: {
        topLeft: 6,
        topRight: 6,
        bottomLeft: 0,
        bottomRight: 0,
      },

      borderSkipped: false,
    },
  ],
});
